import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';
import { timestampToLongDate } from '@educaplay/app-core/time';
import { RenewalText, declineReason } from '../../helpers/renewal';
import { SVG_alert } from '../elements/SVG';

export const BlockLostRenewalNotice = () => {

    const { mainReducer } = useContext( MainContext );

    const lostRenewal = mainReducer.state.lostRenewal;

    if (!lostRenewal) {
        return <></>;
    }

    const values = { plan: getText('plan_name_' + lostRenewal.license), fecha: timestampToLongDate(lostRenewal.lostAt), motivo: declineReason(lostRenewal.family) };

    return  <div className="e-notice e-notice--alert" role="status">
                <span className="e-icon">
                    <SVG_alert />
                </span>
                <div className="e-notice__wrapper">
                    <div className="e-notice__text">
                        <div className="e-notice__title"><RenewalText textKey="lost_renewal_title" values={ values } /></div>
                        <div className="e-notice__body">
                            <RenewalText textKey="lost_renewal_body" values={ values } />
                        </div>
                    </div>
                    <div className="e-notice__btn">
                        <a className="e-btn e-btn--premium" href={ lostRenewal.recoverUrl }>
                            <span className="e-btn__txt">{ getText('lost_renewal_cta') }</span>
                        </a>
                    </div>
                </div>
            </div>;
}
